import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** Доступ только для пользователей с галочкой «Я ученик». */
export default function StudentRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Загрузка...</p>
      </div>
    );
  }

  if (!user?.is_student) {
    return <Navigate to="/" replace />;
  }

  return children;
}
